var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.055,51.313c0,0-7.306-3.971-14.743-12.479c-5.729-6.549-7.573-6.702-16.066-7.062    c-9.054-0.384-17.02-2.824-23.447-7.778c-4.333-3.341-6.629-4.53-5.491-0.501c1.275,4.514,10.6,12.492,10.6,12.492    s-7.929-4.398-8.33-2.083c-0.405,2.316,3.824,6.762,9.438,9.768c4.256,2.28,6.398,2.276,6.398,2.276s-4.425-0.42-7.338-0.826    c-2.528-0.36-2.365,3.115,2.085,5.095c5.558,2.468,11.546,2.242,11.546,2.242s-1.695,0.928-3.397,1.753    c-1.703,0.822-0.539,3.486,3.667,3.578c4.393,0.097,5.558-0.181,5.558-0.181s-3.515,1.112-2.968,3.33    c0.53,2.134,3.125,2.311,5.646,2.788c2.992,0.561,5.783,4.177,5.783,4.177S39.734,72.622,12.92,80.53    c0,0,8.027,2.273,14.652,1.929c0,0-0.417,2.315,2.542,2.667c2.959,0.351,19.709-7.521,19.709-7.521s11.839,1.404,20.611-3.385    c8.776-4.785,13.574-13.556,18.464-15.021c4.883-1.47,7.084-2.181,7.084-2.181s-2.158-3.684-5.709-3.486    c0,0-1.597-4.548-6.469-4.543c0,0,7.655-6.134,10.013-13.358c2.359-7.224-1.3-16.113-5.024-20.77c0,0-1.712,1.146-1.076,3.396    c0,0-2.094-2.024-2.925-0.393c-0.61,1.195,0.45,2.835,0.45,2.835s-1.952-2.033-2.938-0.961c-0.928,1.009,0.39,3.049,0.39,3.049    s-1.649-1.054-2.321,0.316c-0.677,1.365,0.677,3.504,0.677,3.504s-1.394-0.915-2.372,0.646c-0.978,1.56,0.326,4.841,0.326,4.841    s-2.442-0.077-2.838,4.021C75.768,40.222,71.401,46.835,64.055,51.313z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/BIRD.0910b74b636f3f443425cfeb8b88ea2c.svg";
export { ForwardRef as ReactComponent };